// These functions are designed to handle displaying errors in modals
// To use them your modal MUST contain (as first child of .modal-body):
//   <div class="alert alert-error" role="alert" aria-atomic="true" style="display: none"></div>

/**
 * Clear all errors from modal.
 * @param {jQuery} $modal
 */
export function clearErrors($modal) {
    $modal.find('.errors, .alert-error').empty().hide();
}

export function fdsReset($modal) {
    clearErrors($modal);
    $modal.find('.form-group').removeClass('form-error');
    $modal.find('.form-error-message').remove();
    $modal.find(':input').attr('aria-invalid', 'false').val('');
}

/**
 * Show error in FDS modal.
 * @param {jQuery} $modal
 * @param {string} text
 */
export function fdsShowError($modal, text) {
    clearErrors($modal);
    $modal.find('.alert-error').append(`
        <svg class="icon-svg alert-icon" aria-label="Fejl" focusable="false"><use xlink:href="#highlight-off"></use></svg>
        <div class="alert-body">
            <h2 class="alert-heading">Fejl</h2>
            <p class="alert-text">${text}</p>
        </div>
    `).show();
}

export function fdsShowFieldError($field, error, classes = '') {
    const errorId = $field.attr('id') + '-error';
    $field.closest('.form-group').addClass('form-error');
    $field.siblings('.form-error-message').remove();
    $field.before(`<span class="form-error-message ${classes}" id="${errorId}"><span class="sr-only">Fejl: </span>${error}</span>`);
    $field.attr('aria-invalid', 'true');
    if (!($field.attr('aria-describedby') || '').includes(errorId)) {
        $field.attr('aria-describedby', (i, val) => `${val} ${errorId}`);
    }
}

export function fdsClearFieldError($field) {
    const errorId = $field.attr('id') + '-error';
    $field.closest('.form-group').removeClass('form-error');
    $field.siblings('.form-error-message').remove();
    $field.attr('aria-invalid', 'false');
    if (($field.attr('aria-describedby') || '') !== '') {
        $field.attr('aria-describedby', (i, val) => val.replace(errorId, ''));
    }
}
